var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%","height":"calc(100vh - 84px)"},attrs:{"id":_vm.mapId,"element-loading-text":_vm.loadingText,"element-loading-spinner":"el-icon-loading"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }